<template>
  <div class="center">
    <div style="font-size: 18px; font-weight: 700">帮助中心</div>
    <div class="vies">
        <div class="view_item" v-for="(em, idx) in answer" :key="idx">
        <div class="view view1">
          <span class="min">问：</span>
          <span class="item_v">{{ em.question }}</span>
        </div>
        <div class="view" v-for="(answer,i) in em.answer.split('<br>')" :key="i">
          <span class="min" v-if="i==0">答：</span>
          <span class="min" v-else></span>
          <span class="item_v">
            {{ answer}}
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="vies" v-for="(item, index) in answer" :key="index">
      <div class="as_t">{{ item.name }}</div>
      <div class="view_item" v-for="(em, idx) in item.elements" :key="idx">
        <div class="view view1">
          <div class="min">问：</div>
          <div class="item_v">{{ em.question }}</div>
        </div>
        <div class="view" v-for="(answer,i) in em.answer.split('<br>')" :key="i">
          <div class="min" v-if="i==0">答：</div>
          <div class="min" v-else></div>
          <div class="item_v">
            {{ answer}}
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { get_list_part , get_list_faq} from '@/api/system'
export default {
  data() {
    return {
      answer: [],
    }
  },
  activated() {},
  watch: {},
  created() {
    // get_list_part
    get_list_faq().then((res) => {
      console.log(res.data[0].list, 'res.data===============================')
      this.answer = res.data[0].list
    })
  },
  mounted() {},
  methods: {},
}
</script>
<style lang='less' scoped>
.center {
  width: 60%;
  height: 100vh;
  overflow-y: scroll;
  margin-left: 50%;
  padding: 30px 20px 20px 20px;
  box-sizing: border-box;
  font-family: '微软雅黑';
  transform: translateX(-50%);
  &::-webkit-scrollbar {
    display: none;
  }
  .vies {
    width: 100%;
    float: left;
    .as_t {
      width: 100%;
      height: 45px;
      font-size: 20px;
      line-height: 45px;
      font-weight: 600;
    }
    .view_item{
        width: 100%;
        float: left;
        .view1{
            font-weight: 600;
        }
        .view{
            width: 100%;
            float: left;
            margin-bottom: 10px;
            .min{
                width: 30px;
                min-height: 1px;
                float: left;
            }
            .item_v{
                width: calc(100% - 30px);
                float: left;
            }
        }
    }
  }
}
</style>
